import React, { FC, useRef, useState } from 'react'
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player'
import { BsPauseBtn, BsPlayBtn } from 'react-icons/bs'
import 'react-h5-audio-player/lib/styles.css'

const AppAudioPlayerComponent: FC<{ audioSrc: string | undefined }> = ({
  audioSrc,
}) => {
  const playerRef = useRef(null)

  const [playbackRate, setPlaybackRate] = useState(1.0)

  const handleRateChange = (e: any) => {
    const rate = e.target.value
    if (playerRef && playerRef.current) {
      // @ts-ignore
      playerRef.current.audio.current.playbackRate = rate
    }
    setPlaybackRate(rate)
  }
  return (
    <div>
      {audioSrc ? (
        <>
          <AudioPlayer
            ref={playerRef}
            src={audioSrc}
            showJumpControls={false}
            className=""
            layout="horizontal-reverse"
            customControlsSection={[RHAP_UI.MAIN_CONTROLS]}
            customIcons={{
              play: <BsPlayBtn className="text-primary"></BsPlayBtn>,
              pause: <BsPauseBtn className="text-primary"></BsPauseBtn>,
            }}
          />
          <div className="d-flex mt-2">
            <span className="pe-2 fw-bold">{playbackRate}x</span>
            <input
              className="w-100"
              type="range"
              min="1.0"
              max="1.5"
              step="0.05"
              value={playbackRate}
              onChange={handleRateChange}
            />
          </div>
        </>
      ) : (
        <strong>Audio ještě není vygenerováno</strong>
      )}
    </div>
  )
}

export default AppAudioPlayerComponent
